import {
  API_COUPON_LIST,
  API_UPDATE_FAVOR_COUPON,
  API_COUPON_SHOP_LIST,
  API_NEW_LIMITED_COUPON,
} from '@utils/api'
import { genre } from '@state/modules/facility-search'
import $ from '@utils/axios'

// import axios from 'axios'
const prefectures = {
  '1': '北海道',
  '2': '青森県',
  '3': '岩手県',
  '4': '宮城県',
  '5': '秋田県',
  '6': '山形県',
  '7': '福島県',
  '8': '茨城県',
  '9': '栃木県',
  '10': '群馬県',
  '11': '埼玉県',
  '12': '千葉県',
  '13': '東京都',
  '14': '神奈川県',
  '15': '新潟県',
  '16': '富山県',
  '17': '石川県',
  '18': '福井県',
  '19': '山梨県',
  '20': '長野県',
  '21': '岐阜県',
  '22': '静岡県',
  '23': '愛知県',
  '24': '三重県',
  '25': '滋賀県',
  '26': '京都府',
  '27': '大阪府',
  '28': '兵庫県',
  '29': '奈良県',
  '30': '和歌山県',
  '31': '鳥取県',
  '32': '島根県',
  '33': '岡山県',
  '34': '広島県',
  '35': '山口県',
  '36': '徳島県',
  '37': '香川県',
  '38': '愛媛県',
  '39': '高知県',
  '40': '福岡県',
  '41': '佐賀県',
  '42': '長崎県',
  '43': '熊本県',
  '44': '大分県',
  '45': '宮崎県',
  '46': '鹿児島県',
  '47': '沖縄県',
}

export const areas = {
  '101': '北海道',
  '102': '東北',
  '103': '関東甲信越',
  '104': '東海・北陸',
  '105': '近畿',
  '106': '中国',
  '107': '四国',
  '108': '九州・沖縄',
}

export const state = {
  area: '',
  genres: '',
  condition: 1, // なし：0 イチオシ：1 新着：2
  coupons: [],
  showTag: false,
  searchTagId: '',
  tags: [],
  brands: [],
  shops: [],
  selectedBrand: '',
  scrollToTop: true,
  isClipped: false, // お気に入り画面へ戻る時データ更新フラグ
  preview: '',
  coupon_no: '',
  newLimitedCouponCount: 0,
}
export const getters = {
  areaText: (state) => {
    if (state.area === '') {
      return ''
    }
    if (state.area.length === 3) {
      if (areas[state.area]) {
        return areas[state.area]
      } else {
        return ''
      }
    }
    if (state.area.length === 2 || state.area.length === 1) {
      var area = '' + parseInt(state.area)
      if (prefectures[area]) {
        return prefectures[area]
      } else {
        return ''
      }
    }
    return ''
  },
  genreText: (state) => {
    // genreText をcoupon-list.vue のfilterText にいれて画面表示をさせる。
    if (state.genres === '') {
      return ''
    }
    if (state.genres.length === 2) {
      // サブジャンル選択があり、サブジャンルに”すべて”以外を選択した場合の表示。A2 ならsliceでＡを切り取りメインジャンルを取得する。
      // ここで使われている「genre」はインポートしたfacility-search.jsのgenreのリストのこと。coupon-genre.vueとcoupon-sub-genre.vueで使われているgenre.jsのリストではない。
      const targetNewGenre = genre.find(
        (v) => v.code === state.genres.slice(0, 1)
      )
      const targetGenre = genre.find((v) => v.code === state.genres)
      return targetNewGenre.name + ' ' + targetGenre.name
    } else {
      if (
        // サブジャンル選択が無い場合の表示。メインジャンル名のみを表示。
        state.genres === 'E' || // 温泉・入浴施設
        state.genres === 'Q' || // 道の駅
        state.genres === 'M' // SA・PA（サービスエリア）
      ) {
        const targetGenre = genre.find((v) => v.code === state.genres)
        return targetGenre.name
      } else {
        // サブジャンルに”すべて”を選択した場合の表示。メインジャンルと”すべて”を表示する。
        const targetGenre = genre.find((v) => v.code === state.genres)
        return targetGenre.name + ' ' + 'すべて'
      }
    }
  },
  isClipped: (state) => {
    return state.isClipped
  },
}

export const mutations = {
  SET_AREA(state, newValue) {
    state.area = newValue
  },
  SET_GENRE(state, newValue) {
    // 下にある、setGenreの時に使われている。coupon-genre.vueとcoupon-sub-genre.vueでdispatch(発信)したgenre.jsのcodeやsubGenreCodeがnewValueとなる。
    state.genres = newValue
  },
  SET_CONDITION(state, newValue) {
    state.condition = newValue
  },
  SET_SHOWTAG(state, newValue) {
    state.showTag = newValue
  },
  SET_SEARCH_TAG_ID(state, newValue) {
    state.searchTagId = newValue
  },
  SET_TAGS(state, newValue) {
    state.tags = newValue
  },
  SET_COUPONS(state, newValue) {
    state.coupons = newValue
  },
  SET_SHOPS(state, newValue) {
    state.shops = newValue
  },
  SET_SELECTEDBRAND(state, newValue) {
    state.selectedBrand = newValue
  },
  SET_BRANDS(state, newValue) {
    state.brands = newValue
  },
  SET_SCROLLTOTOP(state, newValue) {
    state.scrollToTop = newValue
  },
  SET_ISCLIPPED: (state, newValue) => {
    state.isClipped = newValue
  },
  SET_PREVIEW(state, newValue) {
    state.preview = newValue
  },
  SET_COUPON_NO(state, newValue) {
    state.coupon_no = newValue
  },
  SET_NEWLIMITEDCOUPONCOUNT(state, newValue) {
    state.newLimitedCouponCount = newValue
  },
}

export const actions = {
  clearCoupons({ commit, state, rootState }) {
    commit('SET_COUPONS', [])
  },
  async fetchCoupons({ commit, state, rootState }, updateBrands = true,updateTags = true) {
    // クーポンを取り出す動き
    const params = {}
    params.type = 5
    params.session_id = rootState.auth.sessionId
    if (state.selectedBrand.length !== 0) {
      params.BRAND_ID = state.selectedBrand
    }
    if (state.preview !== '') {
      params.PREVIEW = state.preview
      params.COUPON_NO = state.coupon_no
    } else if (state.condition === 1) {
      params.recommend_flag = 1
    } else if (state.condition === 2) {
      params.sort_flag = 1
    } else if (state.area !== '') {
      params.area = state.area
    } else if (state.genres !== '') {
      params.GENRE = state.genres
    }
    try {
      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      const response = await $.post(API_COUPON_LIST, formData)
      const coupons = Object.values(response.data.coupon)
      commit('SET_COUPONS', coupons)
      if (updateBrands) {
        const brands = Object.values(response.data.brand)
        commit('SET_BRANDS', brands)
      }
      if (updateTags) {
        const tags = Object.values(response.data.search_tag)
        commit('SET_TAGS', tags)
      }
      return coupons
    } catch (e) {}
  },
  async fetchTagCoupons({ commit, state, rootState }) {
    // クーポンを取り出す動き

    const formData = new FormData()
    formData.append('session_id', rootState.auth.sessionId)
    formData.append('type', 5)

    if (state.searchTagId !== '') {
      formData.append('SEARCH_TAG_ID', state.searchTagId)
    }
    try {
      const response = await $.post(API_COUPON_LIST, formData)
      const coupons = Object.values(response.data.coupon)
      commit('SET_COUPONS', coupons)
      const tags = Object.values(response.data.search_tag)
      commit('SET_TAGS', tags)
      return coupons
    } catch (e) {}
  },
  async fetchCoupon({ commit, state, rootState }, { id, longitude, latitude }) {
    const params = {}
    params.type = 6
    params.session_id = rootState.auth.sessionId
    params.COUPON_NO = id
    if (longitude) {
      params.LONGITUDE = longitude
    }
    if (latitude) {
      params.LATITUDE = latitude
    }
    if (state.preview !== '') {
      params.PREVIEW = state.preview
    }
    params.nocache = new Date().getTime()
    try {
      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      const response = await $.post(API_COUPON_LIST, formData)
      // if (response.data.status_code !== '00') {
      //   throw new Error(response.data.error_code)
      // }
      // if (
      //   Object.keys(response.data.coupon).length === 0 &&
      //   response.data.coupon.constructor === Object
      // ) {
      //   const e = new Error('このクーポンの掲載は終了しました。')
      //   e.name = 'noCoupon'
      //   throw e
      // }
      return response.data.coupon
    } catch (e) {
      //   if (e.message === 'Network Error') {
      //     const error = new Error(
      //       '通信に失敗しました。通信状況を確認し、再度お試し下さい'
      //     )
      //     error.name = 'networkError'
      //     throw error
      //   } else {
      //     throw e
      //   }
    }
  },
  async clipCoupon({ commit, state, rootState }, COUPON_NO) {
    const formData = new FormData()
    formData.append('session_id', rootState.auth.sessionId)
    formData.append('COUPON_NO', COUPON_NO)
    try {
      if (state.preview !== '') {
      } else {
        await $.post(API_UPDATE_FAVOR_COUPON, formData)
      }
      commit('SET_ISCLIPPED', true)
      // const response = await $.post(API_UPDATE_FAVOR_COUPON, formData)
      // if (response.data.status_code !== '00') {
      //   throw new Error(response.data.error_code)
      // }
    } catch (e) {}
  },
  async unclipCoupon({ commit, state, rootState }, COUPON_NO) {
    const formData = new FormData()
    formData.append('session_id', rootState.auth.sessionId)
    formData.append('COUPON_NO', COUPON_NO)
    formData.append('DELETED', 1)
    try {
      if (state.preview !== '') {
      } else {
        await $.post(API_UPDATE_FAVOR_COUPON, formData)
      }
      commit('SET_ISCLIPPED', false)
      // const response = await $.post(API_UPDATE_FAVOR_COUPON, formData)
      // if (response.data.status_code !== '00') {
      //   throw new Error(response.data.error_code)
      // }
    } catch (e) {}
  },
  clearShops({ commit, state, rootState }) {
    commit('SET_SHOPS', [])
  },
  async fetchShops({ commit, state, rootState }, { id, longitude, latitude }) {
    const params = {}
    params.session_id = rootState.auth.sessionId
    params.COUPON_NO = id
    params.LONGITUDE = 0.0
    params.LATITUDE = 0.0
    params.MODE = 1
    params.SORT = 2
    if (longitude) {
      params.LONGITUDE = longitude
    }
    if (latitude) {
      params.LATITUDE = latitude
    }
    params.customConfig = {
      withoutLoading: true,
    }
    if (state.preview !== '') {
      params.PREVIEW = state.preview
    }

    try {
      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      const response = await $.post(API_COUPON_SHOP_LIST, formData)
      // if (response.data.status_code !== '00') {
      //   throw new Error(response.data.error_code)
      // }
      // if (
      //   Object.keys(response.data.coupon).length === 0 &&
      //   response.data.coupon.constructor === Object
      // ) {
      //   const e = new Error('このクーポンの掲載は終了しました。')
      //   e.name = 'noCoupon'
      //   throw e
      // }
      return response.data.shop
    } catch (e) {
      //   if (e.message === 'Network Error') {
      //     const error = new Error(
      //       '通信に失敗しました。通信状況を確認し、再度お試し下さい'
      //     )
      //     error.name = 'networkError'
      //     throw error
      //   } else {
      //     throw e
      //   }
    }
  },
  clearSelectedBrand({ commit, state, rootState }) {
    commit('SET_SELECTEDBRAND', '')
  },
  selectBrand({ commit, state, rootState }, brand) {
    commit('SET_SELECTEDBRAND', brand)
  },
  changeToRecommend({ commit, state, rootState }) {
    commit('SET_AREA', '')
    commit('SET_GENRE', '')
    commit('SET_CONDITION', 1)
    commit('SET_SHOWTAG', false)
    commit('SET_SELECTEDBRAND', '')
    commit('SET_SCROLLTOTOP', true)
  },
  changeToNew({ commit, state, rootState }) {
    commit('SET_AREA', '')
    commit('SET_GENRE', '')
    commit('SET_CONDITION', 2)
    commit('SET_SHOWTAG', false)
    commit('SET_SELECTEDBRAND', '')
    commit('SET_SCROLLTOTOP', true)
  },
  clearFilter({ commit, state, rootState }) {
    commit('SET_AREA', '')
    commit('SET_GENRE', '')
    commit('SET_CONDITION', 0)
    commit('SET_SCROLLTOTOP', true)
  },
  setArea({ commit, state, rootState }, area) {
    commit('SET_AREA', area)
    commit('SET_CONDITION', 0)
    commit('SET_SELECTEDBRAND', '')
    commit('SET_SCROLLTOTOP', true)
  },
  setGenre({ commit, state, rootState }, genres) {
    // coupon-genre.vueとcoupon-sub-genre.vueのcodeやsubGenreCodeを保存する。BやF2など。サブジャンルがある場合はジャンルコードを上書きする。
    commit('SET_AREA', '')
    commit('SET_GENRE', genres)
    commit('SET_CONDITION', 0)
    commit('SET_SELECTEDBRAND', '')
    commit('SET_SCROLLTOTOP', true)
  },
  setShowTag({ commit, state, rootState }, showFlag) {
    commit('SET_SHOWTAG', showFlag)
  },
  setSearchTagId({ commit, state, rootState }, searchTagId) {
    commit('SET_SEARCH_TAG_ID', searchTagId)
  },
  restoreScrollToTop({ commit, state, rootState }) {
    commit('SET_SCROLLTOTOP', false)
  },
  setPreview({ commit, state, rootState }, previewData) {
    commit('SET_PREVIEW', previewData.preview)
    commit('SET_COUPON_NO', previewData.coupon_no)
  },
  async isPreviewMode({ commit, state, rootState }) {
    var ret = false
    if (state.preview !== '') {
      ret = true
    } else {
      ret = false
    }
    return ret
  },
}
